import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';

export interface PostCheckOrgAvailabilityPayload {
  title?: string;
  sub?: string;
}

export async function postCheckOrgAvailabilityInternalApi({
  host,
  ...restProps
}: PostCheckOrgAvailabilityPayload & { host: string }): Promise<string[]> {
  const response = await axiosClient.post<string[]>(`${assertServiceHost(host)}/v1/orgAvailability`, {
    ...restProps,
  });
  return response.data;
}
